<router-outlet />

<app-session-expired-modal [open]="sessionExpired" (reconnect)="onSessionReconnect()" />
